/**
 * Accedo OVP
 * API version: 1.2.0
 *
 * NOTE: This class was automatically generated by Swagger Code Generator. Do not edit it manually.
 */
'use strict';

var ApiClient = require('../ApiClient');
var Category = require('./Category');




  /**
   * The Category model module.
   * @module model/Category
   * @version 1.4.0
   */

  /**
   * Constructs a new <code>Category</code>.
   * @alias module:model/Category
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>Category</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Category} obj Optional instance to populate.
   * @return {module:model/Category} The populated <code>Category</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('categories')) {
        obj['categories'] = ApiClient.convertToType(data['categories'], [Category]);
      }
    }
    return obj;
  };

  /**
   * identifier for the category
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * name of the category
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * description for the category
   * @member {String} description
   */
  exports.prototype['description'] = undefined;
  /**
   * list of sub-categories, without further elaboration on sub-categories
   * @member {Array.<module:model/Category>} categories
   */
  exports.prototype['categories'] = undefined;







module.exports = exports;